module.exports = __webpack_public_path__ + "media/images/front/event/jump-icon-bcf7ddc983a8d8ca80a5acf3779d90f2.svg";